/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as SponsorsRouteImport } from './routes/sponsors'
import { Route as SampleRouteImport } from './routes/sample'
import { Route as ResearchRouteImport } from './routes/research'
import { Route as PitchRouteImport } from './routes/pitch'
import { Route as NewsRouteImport } from './routes/news'
import { Route as HomepagesRouteImport } from './routes/homepages'
import { Route as HomeRouteImport } from './routes/home'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as BoardRouteImport } from './routes/board'
import { Route as BeautyShowRouteImport } from './routes/beauty-show'
import { Route as AwardsRouteImport } from './routes/awards'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as NewsletterSlugRouteImport } from './routes/newsletter.$slug'
import { Route as NewsPreviewRouteImport } from './routes/news_.preview'
import { Route as NewsSlugRouteImport } from './routes/news_.$slug'
import { Route as GalleryPermalinkRouteImport } from './routes/gallery.$permalink'
import { Route as BeautyShowPermalinkRouteImport } from './routes/beauty-show.$permalink'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminTrafficRouteImport } from './routes/_authenticated/admin.traffic'
import { Route as AuthenticatedAdminThemeRouteImport } from './routes/_authenticated/admin.theme'
import { Route as AuthenticatedAdminTemplatesRouteImport } from './routes/_authenticated/admin.templates'
import { Route as AuthenticatedAdminTeamRouteImport } from './routes/_authenticated/admin.team'
import { Route as AuthenticatedAdminSponsorsRouteImport } from './routes/_authenticated/admin.sponsors'
import { Route as AuthenticatedAdminSlideshowRouteImport } from './routes/_authenticated/admin.slideshow'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminResearchRouteImport } from './routes/_authenticated/admin.research'
import { Route as AuthenticatedAdminNewsletterRouteImport } from './routes/_authenticated/admin.newsletter'
import { Route as AuthenticatedAdminNewsRouteImport } from './routes/_authenticated/admin.news'
import { Route as AuthenticatedAdminNavigationRouteImport } from './routes/_authenticated/admin.navigation'
import { Route as AuthenticatedAdminMessagesRouteImport } from './routes/_authenticated/admin.messages'
import { Route as AuthenticatedAdminMediaRouteImport } from './routes/_authenticated/admin.media'
import { Route as AuthenticatedAdminLayoutsRouteImport } from './routes/_authenticated/admin.layouts'
import { Route as AuthenticatedAdminIssuesRouteImport } from './routes/_authenticated/admin.issues'
import { Route as AuthenticatedAdminHealthRouteImport } from './routes/_authenticated/admin.health'
import { Route as AuthenticatedAdminGalleryRouteImport } from './routes/_authenticated/admin.gallery'
import { Route as AuthenticatedAdminEventsRouteImport } from './routes/_authenticated/admin.events'
import { Route as AuthenticatedAdminContentRouteImport } from './routes/_authenticated/admin.content'
import { Route as AuthenticatedAdminBoardRouteImport } from './routes/_authenticated/admin.board'
import { Route as AuthenticatedAdminBeautyShowRouteImport } from './routes/_authenticated/admin.beauty-show'
import { Route as AuthenticatedAdminAwardsRouteImport } from './routes/_authenticated/admin.awards'
import { Route as AuthenticatedAdminAdvisorsRouteImport } from './routes/_authenticated/admin.advisors'
import { Route as AuthenticatedAdminIssuesIdRouteImport } from './routes/_authenticated/admin.issues.$id'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsorsRoute = SponsorsRouteImport.update({
  id: '/sponsors',
  path: '/sponsors',
  getParentRoute: () => rootRouteImport,
} as any)
const SampleRoute = SampleRouteImport.update({
  id: '/sample',
  path: '/sample',
  getParentRoute: () => rootRouteImport,
} as any)
const ResearchRoute = ResearchRouteImport.update({
  id: '/research',
  path: '/research',
  getParentRoute: () => rootRouteImport,
} as any)
const PitchRoute = PitchRouteImport.update({
  id: '/pitch',
  path: '/pitch',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsRoute = NewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => rootRouteImport,
} as any)
const HomepagesRoute = HomepagesRouteImport.update({
  id: '/homepages',
  path: '/homepages',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardRoute = BoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => rootRouteImport,
} as any)
const BeautyShowRoute = BeautyShowRouteImport.update({
  id: '/beauty-show',
  path: '/beauty-show',
  getParentRoute: () => rootRouteImport,
} as any)
const AwardsRoute = AwardsRouteImport.update({
  id: '/awards',
  path: '/awards',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PSlugRoute = PSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsletterSlugRoute = NewsletterSlugRouteImport.update({
  id: '/newsletter/$slug',
  path: '/newsletter/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsPreviewRoute = NewsPreviewRouteImport.update({
  id: '/news_/preview',
  path: '/news/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsSlugRoute = NewsSlugRouteImport.update({
  id: '/news_/$slug',
  path: '/news/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryPermalinkRoute = GalleryPermalinkRouteImport.update({
  id: '/$permalink',
  path: '/$permalink',
  getParentRoute: () => GalleryRoute,
} as any)
const BeautyShowPermalinkRoute = BeautyShowPermalinkRouteImport.update({
  id: '/$permalink',
  path: '/$permalink',
  getParentRoute: () => BeautyShowRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminTrafficRoute =
  AuthenticatedAdminTrafficRouteImport.update({
    id: '/traffic',
    path: '/traffic',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminThemeRoute = AuthenticatedAdminThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminTemplatesRoute =
  AuthenticatedAdminTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminTeamRoute = AuthenticatedAdminTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminSponsorsRoute =
  AuthenticatedAdminSponsorsRouteImport.update({
    id: '/sponsors',
    path: '/sponsors',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSlideshowRoute =
  AuthenticatedAdminSlideshowRouteImport.update({
    id: '/slideshow',
    path: '/slideshow',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminResearchRoute =
  AuthenticatedAdminResearchRouteImport.update({
    id: '/research',
    path: '/research',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminNewsletterRoute =
  AuthenticatedAdminNewsletterRouteImport.update({
    id: '/newsletter',
    path: '/newsletter',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminNewsRoute = AuthenticatedAdminNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminNavigationRoute =
  AuthenticatedAdminNavigationRouteImport.update({
    id: '/navigation',
    path: '/navigation',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminMessagesRoute =
  AuthenticatedAdminMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminMediaRoute = AuthenticatedAdminMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminLayoutsRoute =
  AuthenticatedAdminLayoutsRouteImport.update({
    id: '/layouts',
    path: '/layouts',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminIssuesRoute =
  AuthenticatedAdminIssuesRouteImport.update({
    id: '/issues',
    path: '/issues',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminHealthRoute =
  AuthenticatedAdminHealthRouteImport.update({
    id: '/health',
    path: '/health',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminGalleryRoute =
  AuthenticatedAdminGalleryRouteImport.update({
    id: '/gallery',
    path: '/gallery',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminEventsRoute =
  AuthenticatedAdminEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminContentRoute =
  AuthenticatedAdminContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBoardRoute = AuthenticatedAdminBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminBeautyShowRoute =
  AuthenticatedAdminBeautyShowRouteImport.update({
    id: '/beauty-show',
    path: '/beauty-show',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAwardsRoute =
  AuthenticatedAdminAwardsRouteImport.update({
    id: '/awards',
    path: '/awards',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdvisorsRoute =
  AuthenticatedAdminAdvisorsRouteImport.update({
    id: '/advisors',
    path: '/advisors',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminIssuesIdRoute =
  AuthenticatedAdminIssuesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAdminIssuesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/auth': typeof AuthRoute
  '/awards': typeof AwardsRoute
  '/beauty-show': typeof BeautyShowRouteWithChildren
  '/board': typeof BoardRoute
  '/gallery': typeof GalleryRouteWithChildren
  '/home': typeof HomeRoute
  '/homepages': typeof HomepagesRoute
  '/news': typeof NewsRoute
  '/pitch': typeof PitchRoute
  '/research': typeof ResearchRoute
  '/sample': typeof SampleRoute
  '/sponsors': typeof SponsorsRoute
  '/welcome': typeof WelcomeRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/beauty-show/$permalink': typeof BeautyShowPermalinkRoute
  '/gallery/$permalink': typeof GalleryPermalinkRoute
  '/news/$slug': typeof NewsSlugRoute
  '/news/preview': typeof NewsPreviewRoute
  '/newsletter/$slug': typeof NewsletterSlugRoute
  '/p/$slug': typeof PSlugRoute
  '/admin/advisors': typeof AuthenticatedAdminAdvisorsRoute
  '/admin/awards': typeof AuthenticatedAdminAwardsRoute
  '/admin/beauty-show': typeof AuthenticatedAdminBeautyShowRoute
  '/admin/board': typeof AuthenticatedAdminBoardRoute
  '/admin/content': typeof AuthenticatedAdminContentRoute
  '/admin/events': typeof AuthenticatedAdminEventsRoute
  '/admin/gallery': typeof AuthenticatedAdminGalleryRoute
  '/admin/health': typeof AuthenticatedAdminHealthRoute
  '/admin/issues': typeof AuthenticatedAdminIssuesRouteWithChildren
  '/admin/layouts': typeof AuthenticatedAdminLayoutsRoute
  '/admin/media': typeof AuthenticatedAdminMediaRoute
  '/admin/messages': typeof AuthenticatedAdminMessagesRoute
  '/admin/navigation': typeof AuthenticatedAdminNavigationRoute
  '/admin/news': typeof AuthenticatedAdminNewsRoute
  '/admin/newsletter': typeof AuthenticatedAdminNewsletterRoute
  '/admin/research': typeof AuthenticatedAdminResearchRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/slideshow': typeof AuthenticatedAdminSlideshowRoute
  '/admin/sponsors': typeof AuthenticatedAdminSponsorsRoute
  '/admin/team': typeof AuthenticatedAdminTeamRoute
  '/admin/templates': typeof AuthenticatedAdminTemplatesRoute
  '/admin/theme': typeof AuthenticatedAdminThemeRoute
  '/admin/traffic': typeof AuthenticatedAdminTrafficRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/admin/issues/$id': typeof AuthenticatedAdminIssuesIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/auth': typeof AuthRoute
  '/awards': typeof AwardsRoute
  '/beauty-show': typeof BeautyShowRouteWithChildren
  '/board': typeof BoardRoute
  '/gallery': typeof GalleryRouteWithChildren
  '/home': typeof HomeRoute
  '/homepages': typeof HomepagesRoute
  '/news': typeof NewsRoute
  '/pitch': typeof PitchRoute
  '/research': typeof ResearchRoute
  '/sample': typeof SampleRoute
  '/sponsors': typeof SponsorsRoute
  '/welcome': typeof WelcomeRoute
  '/beauty-show/$permalink': typeof BeautyShowPermalinkRoute
  '/gallery/$permalink': typeof GalleryPermalinkRoute
  '/news/$slug': typeof NewsSlugRoute
  '/news/preview': typeof NewsPreviewRoute
  '/newsletter/$slug': typeof NewsletterSlugRoute
  '/p/$slug': typeof PSlugRoute
  '/admin/advisors': typeof AuthenticatedAdminAdvisorsRoute
  '/admin/awards': typeof AuthenticatedAdminAwardsRoute
  '/admin/beauty-show': typeof AuthenticatedAdminBeautyShowRoute
  '/admin/board': typeof AuthenticatedAdminBoardRoute
  '/admin/content': typeof AuthenticatedAdminContentRoute
  '/admin/events': typeof AuthenticatedAdminEventsRoute
  '/admin/gallery': typeof AuthenticatedAdminGalleryRoute
  '/admin/health': typeof AuthenticatedAdminHealthRoute
  '/admin/issues': typeof AuthenticatedAdminIssuesRouteWithChildren
  '/admin/layouts': typeof AuthenticatedAdminLayoutsRoute
  '/admin/media': typeof AuthenticatedAdminMediaRoute
  '/admin/messages': typeof AuthenticatedAdminMessagesRoute
  '/admin/navigation': typeof AuthenticatedAdminNavigationRoute
  '/admin/news': typeof AuthenticatedAdminNewsRoute
  '/admin/newsletter': typeof AuthenticatedAdminNewsletterRoute
  '/admin/research': typeof AuthenticatedAdminResearchRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/slideshow': typeof AuthenticatedAdminSlideshowRoute
  '/admin/sponsors': typeof AuthenticatedAdminSponsorsRoute
  '/admin/team': typeof AuthenticatedAdminTeamRoute
  '/admin/templates': typeof AuthenticatedAdminTemplatesRoute
  '/admin/theme': typeof AuthenticatedAdminThemeRoute
  '/admin/traffic': typeof AuthenticatedAdminTrafficRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/admin/issues/$id': typeof AuthenticatedAdminIssuesIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/auth': typeof AuthRoute
  '/awards': typeof AwardsRoute
  '/beauty-show': typeof BeautyShowRouteWithChildren
  '/board': typeof BoardRoute
  '/gallery': typeof GalleryRouteWithChildren
  '/home': typeof HomeRoute
  '/homepages': typeof HomepagesRoute
  '/news': typeof NewsRoute
  '/pitch': typeof PitchRoute
  '/research': typeof ResearchRoute
  '/sample': typeof SampleRoute
  '/sponsors': typeof SponsorsRoute
  '/welcome': typeof WelcomeRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/beauty-show/$permalink': typeof BeautyShowPermalinkRoute
  '/gallery/$permalink': typeof GalleryPermalinkRoute
  '/news_/$slug': typeof NewsSlugRoute
  '/news_/preview': typeof NewsPreviewRoute
  '/newsletter/$slug': typeof NewsletterSlugRoute
  '/p/$slug': typeof PSlugRoute
  '/_authenticated/admin/advisors': typeof AuthenticatedAdminAdvisorsRoute
  '/_authenticated/admin/awards': typeof AuthenticatedAdminAwardsRoute
  '/_authenticated/admin/beauty-show': typeof AuthenticatedAdminBeautyShowRoute
  '/_authenticated/admin/board': typeof AuthenticatedAdminBoardRoute
  '/_authenticated/admin/content': typeof AuthenticatedAdminContentRoute
  '/_authenticated/admin/events': typeof AuthenticatedAdminEventsRoute
  '/_authenticated/admin/gallery': typeof AuthenticatedAdminGalleryRoute
  '/_authenticated/admin/health': typeof AuthenticatedAdminHealthRoute
  '/_authenticated/admin/issues': typeof AuthenticatedAdminIssuesRouteWithChildren
  '/_authenticated/admin/layouts': typeof AuthenticatedAdminLayoutsRoute
  '/_authenticated/admin/media': typeof AuthenticatedAdminMediaRoute
  '/_authenticated/admin/messages': typeof AuthenticatedAdminMessagesRoute
  '/_authenticated/admin/navigation': typeof AuthenticatedAdminNavigationRoute
  '/_authenticated/admin/news': typeof AuthenticatedAdminNewsRoute
  '/_authenticated/admin/newsletter': typeof AuthenticatedAdminNewsletterRoute
  '/_authenticated/admin/research': typeof AuthenticatedAdminResearchRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/slideshow': typeof AuthenticatedAdminSlideshowRoute
  '/_authenticated/admin/sponsors': typeof AuthenticatedAdminSponsorsRoute
  '/_authenticated/admin/team': typeof AuthenticatedAdminTeamRoute
  '/_authenticated/admin/templates': typeof AuthenticatedAdminTemplatesRoute
  '/_authenticated/admin/theme': typeof AuthenticatedAdminThemeRoute
  '/_authenticated/admin/traffic': typeof AuthenticatedAdminTrafficRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/admin/issues/$id': typeof AuthenticatedAdminIssuesIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/auth'
    | '/awards'
    | '/beauty-show'
    | '/board'
    | '/gallery'
    | '/home'
    | '/homepages'
    | '/news'
    | '/pitch'
    | '/research'
    | '/sample'
    | '/sponsors'
    | '/welcome'
    | '/admin'
    | '/beauty-show/$permalink'
    | '/gallery/$permalink'
    | '/news/$slug'
    | '/news/preview'
    | '/newsletter/$slug'
    | '/p/$slug'
    | '/admin/advisors'
    | '/admin/awards'
    | '/admin/beauty-show'
    | '/admin/board'
    | '/admin/content'
    | '/admin/events'
    | '/admin/gallery'
    | '/admin/health'
    | '/admin/issues'
    | '/admin/layouts'
    | '/admin/media'
    | '/admin/messages'
    | '/admin/navigation'
    | '/admin/news'
    | '/admin/newsletter'
    | '/admin/research'
    | '/admin/settings'
    | '/admin/slideshow'
    | '/admin/sponsors'
    | '/admin/team'
    | '/admin/templates'
    | '/admin/theme'
    | '/admin/traffic'
    | '/admin/users'
    | '/admin/'
    | '/admin/issues/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/auth'
    | '/awards'
    | '/beauty-show'
    | '/board'
    | '/gallery'
    | '/home'
    | '/homepages'
    | '/news'
    | '/pitch'
    | '/research'
    | '/sample'
    | '/sponsors'
    | '/welcome'
    | '/beauty-show/$permalink'
    | '/gallery/$permalink'
    | '/news/$slug'
    | '/news/preview'
    | '/newsletter/$slug'
    | '/p/$slug'
    | '/admin/advisors'
    | '/admin/awards'
    | '/admin/beauty-show'
    | '/admin/board'
    | '/admin/content'
    | '/admin/events'
    | '/admin/gallery'
    | '/admin/health'
    | '/admin/issues'
    | '/admin/layouts'
    | '/admin/media'
    | '/admin/messages'
    | '/admin/navigation'
    | '/admin/news'
    | '/admin/newsletter'
    | '/admin/research'
    | '/admin/settings'
    | '/admin/slideshow'
    | '/admin/sponsors'
    | '/admin/team'
    | '/admin/templates'
    | '/admin/theme'
    | '/admin/traffic'
    | '/admin/users'
    | '/admin'
    | '/admin/issues/$id'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/$'
    | '/auth'
    | '/awards'
    | '/beauty-show'
    | '/board'
    | '/gallery'
    | '/home'
    | '/homepages'
    | '/news'
    | '/pitch'
    | '/research'
    | '/sample'
    | '/sponsors'
    | '/welcome'
    | '/_authenticated/admin'
    | '/beauty-show/$permalink'
    | '/gallery/$permalink'
    | '/news_/$slug'
    | '/news_/preview'
    | '/newsletter/$slug'
    | '/p/$slug'
    | '/_authenticated/admin/advisors'
    | '/_authenticated/admin/awards'
    | '/_authenticated/admin/beauty-show'
    | '/_authenticated/admin/board'
    | '/_authenticated/admin/content'
    | '/_authenticated/admin/events'
    | '/_authenticated/admin/gallery'
    | '/_authenticated/admin/health'
    | '/_authenticated/admin/issues'
    | '/_authenticated/admin/layouts'
    | '/_authenticated/admin/media'
    | '/_authenticated/admin/messages'
    | '/_authenticated/admin/navigation'
    | '/_authenticated/admin/news'
    | '/_authenticated/admin/newsletter'
    | '/_authenticated/admin/research'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/slideshow'
    | '/_authenticated/admin/sponsors'
    | '/_authenticated/admin/team'
    | '/_authenticated/admin/templates'
    | '/_authenticated/admin/theme'
    | '/_authenticated/admin/traffic'
    | '/_authenticated/admin/users'
    | '/_authenticated/admin/'
    | '/_authenticated/admin/issues/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  AuthRoute: typeof AuthRoute
  AwardsRoute: typeof AwardsRoute
  BeautyShowRoute: typeof BeautyShowRouteWithChildren
  BoardRoute: typeof BoardRoute
  GalleryRoute: typeof GalleryRouteWithChildren
  HomeRoute: typeof HomeRoute
  HomepagesRoute: typeof HomepagesRoute
  NewsRoute: typeof NewsRoute
  PitchRoute: typeof PitchRoute
  ResearchRoute: typeof ResearchRoute
  SampleRoute: typeof SampleRoute
  SponsorsRoute: typeof SponsorsRoute
  WelcomeRoute: typeof WelcomeRoute
  NewsSlugRoute: typeof NewsSlugRoute
  NewsPreviewRoute: typeof NewsPreviewRoute
  NewsletterSlugRoute: typeof NewsletterSlugRoute
  PSlugRoute: typeof PSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsors': {
      id: '/sponsors'
      path: '/sponsors'
      fullPath: '/sponsors'
      preLoaderRoute: typeof SponsorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sample': {
      id: '/sample'
      path: '/sample'
      fullPath: '/sample'
      preLoaderRoute: typeof SampleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/research': {
      id: '/research'
      path: '/research'
      fullPath: '/research'
      preLoaderRoute: typeof ResearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pitch': {
      id: '/pitch'
      path: '/pitch'
      fullPath: '/pitch'
      preLoaderRoute: typeof PitchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news': {
      id: '/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof NewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/homepages': {
      id: '/homepages'
      path: '/homepages'
      fullPath: '/homepages'
      preLoaderRoute: typeof HomepagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board': {
      id: '/board'
      path: '/board'
      fullPath: '/board'
      preLoaderRoute: typeof BoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beauty-show': {
      id: '/beauty-show'
      path: '/beauty-show'
      fullPath: '/beauty-show'
      preLoaderRoute: typeof BeautyShowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/awards': {
      id: '/awards'
      path: '/awards'
      fullPath: '/awards'
      preLoaderRoute: typeof AwardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$slug': {
      id: '/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof PSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/newsletter/$slug': {
      id: '/newsletter/$slug'
      path: '/newsletter/$slug'
      fullPath: '/newsletter/$slug'
      preLoaderRoute: typeof NewsletterSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news_/preview': {
      id: '/news_/preview'
      path: '/news/preview'
      fullPath: '/news/preview'
      preLoaderRoute: typeof NewsPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news_/$slug': {
      id: '/news_/$slug'
      path: '/news/$slug'
      fullPath: '/news/$slug'
      preLoaderRoute: typeof NewsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery/$permalink': {
      id: '/gallery/$permalink'
      path: '/$permalink'
      fullPath: '/gallery/$permalink'
      preLoaderRoute: typeof GalleryPermalinkRouteImport
      parentRoute: typeof GalleryRoute
    }
    '/beauty-show/$permalink': {
      id: '/beauty-show/$permalink'
      path: '/$permalink'
      fullPath: '/beauty-show/$permalink'
      preLoaderRoute: typeof BeautyShowPermalinkRouteImport
      parentRoute: typeof BeautyShowRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/traffic': {
      id: '/_authenticated/admin/traffic'
      path: '/traffic'
      fullPath: '/admin/traffic'
      preLoaderRoute: typeof AuthenticatedAdminTrafficRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/theme': {
      id: '/_authenticated/admin/theme'
      path: '/theme'
      fullPath: '/admin/theme'
      preLoaderRoute: typeof AuthenticatedAdminThemeRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/templates': {
      id: '/_authenticated/admin/templates'
      path: '/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AuthenticatedAdminTemplatesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/team': {
      id: '/_authenticated/admin/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AuthenticatedAdminTeamRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/sponsors': {
      id: '/_authenticated/admin/sponsors'
      path: '/sponsors'
      fullPath: '/admin/sponsors'
      preLoaderRoute: typeof AuthenticatedAdminSponsorsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/slideshow': {
      id: '/_authenticated/admin/slideshow'
      path: '/slideshow'
      fullPath: '/admin/slideshow'
      preLoaderRoute: typeof AuthenticatedAdminSlideshowRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/research': {
      id: '/_authenticated/admin/research'
      path: '/research'
      fullPath: '/admin/research'
      preLoaderRoute: typeof AuthenticatedAdminResearchRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/newsletter': {
      id: '/_authenticated/admin/newsletter'
      path: '/newsletter'
      fullPath: '/admin/newsletter'
      preLoaderRoute: typeof AuthenticatedAdminNewsletterRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/news': {
      id: '/_authenticated/admin/news'
      path: '/news'
      fullPath: '/admin/news'
      preLoaderRoute: typeof AuthenticatedAdminNewsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/navigation': {
      id: '/_authenticated/admin/navigation'
      path: '/navigation'
      fullPath: '/admin/navigation'
      preLoaderRoute: typeof AuthenticatedAdminNavigationRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/messages': {
      id: '/_authenticated/admin/messages'
      path: '/messages'
      fullPath: '/admin/messages'
      preLoaderRoute: typeof AuthenticatedAdminMessagesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/media': {
      id: '/_authenticated/admin/media'
      path: '/media'
      fullPath: '/admin/media'
      preLoaderRoute: typeof AuthenticatedAdminMediaRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/layouts': {
      id: '/_authenticated/admin/layouts'
      path: '/layouts'
      fullPath: '/admin/layouts'
      preLoaderRoute: typeof AuthenticatedAdminLayoutsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/issues': {
      id: '/_authenticated/admin/issues'
      path: '/issues'
      fullPath: '/admin/issues'
      preLoaderRoute: typeof AuthenticatedAdminIssuesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/health': {
      id: '/_authenticated/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AuthenticatedAdminHealthRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/gallery': {
      id: '/_authenticated/admin/gallery'
      path: '/gallery'
      fullPath: '/admin/gallery'
      preLoaderRoute: typeof AuthenticatedAdminGalleryRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/events': {
      id: '/_authenticated/admin/events'
      path: '/events'
      fullPath: '/admin/events'
      preLoaderRoute: typeof AuthenticatedAdminEventsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/content': {
      id: '/_authenticated/admin/content'
      path: '/content'
      fullPath: '/admin/content'
      preLoaderRoute: typeof AuthenticatedAdminContentRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/board': {
      id: '/_authenticated/admin/board'
      path: '/board'
      fullPath: '/admin/board'
      preLoaderRoute: typeof AuthenticatedAdminBoardRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/beauty-show': {
      id: '/_authenticated/admin/beauty-show'
      path: '/beauty-show'
      fullPath: '/admin/beauty-show'
      preLoaderRoute: typeof AuthenticatedAdminBeautyShowRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/awards': {
      id: '/_authenticated/admin/awards'
      path: '/awards'
      fullPath: '/admin/awards'
      preLoaderRoute: typeof AuthenticatedAdminAwardsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/advisors': {
      id: '/_authenticated/admin/advisors'
      path: '/advisors'
      fullPath: '/admin/advisors'
      preLoaderRoute: typeof AuthenticatedAdminAdvisorsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/issues/$id': {
      id: '/_authenticated/admin/issues/$id'
      path: '/$id'
      fullPath: '/admin/issues/$id'
      preLoaderRoute: typeof AuthenticatedAdminIssuesIdRouteImport
      parentRoute: typeof AuthenticatedAdminIssuesRoute
    }
  }
}

interface AuthenticatedAdminIssuesRouteChildren {
  AuthenticatedAdminIssuesIdRoute: typeof AuthenticatedAdminIssuesIdRoute
}

const AuthenticatedAdminIssuesRouteChildren: AuthenticatedAdminIssuesRouteChildren =
  {
    AuthenticatedAdminIssuesIdRoute: AuthenticatedAdminIssuesIdRoute,
  }

const AuthenticatedAdminIssuesRouteWithChildren =
  AuthenticatedAdminIssuesRoute._addFileChildren(
    AuthenticatedAdminIssuesRouteChildren,
  )

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAdvisorsRoute: typeof AuthenticatedAdminAdvisorsRoute
  AuthenticatedAdminAwardsRoute: typeof AuthenticatedAdminAwardsRoute
  AuthenticatedAdminBeautyShowRoute: typeof AuthenticatedAdminBeautyShowRoute
  AuthenticatedAdminBoardRoute: typeof AuthenticatedAdminBoardRoute
  AuthenticatedAdminContentRoute: typeof AuthenticatedAdminContentRoute
  AuthenticatedAdminEventsRoute: typeof AuthenticatedAdminEventsRoute
  AuthenticatedAdminGalleryRoute: typeof AuthenticatedAdminGalleryRoute
  AuthenticatedAdminHealthRoute: typeof AuthenticatedAdminHealthRoute
  AuthenticatedAdminIssuesRoute: typeof AuthenticatedAdminIssuesRouteWithChildren
  AuthenticatedAdminLayoutsRoute: typeof AuthenticatedAdminLayoutsRoute
  AuthenticatedAdminMediaRoute: typeof AuthenticatedAdminMediaRoute
  AuthenticatedAdminMessagesRoute: typeof AuthenticatedAdminMessagesRoute
  AuthenticatedAdminNavigationRoute: typeof AuthenticatedAdminNavigationRoute
  AuthenticatedAdminNewsRoute: typeof AuthenticatedAdminNewsRoute
  AuthenticatedAdminNewsletterRoute: typeof AuthenticatedAdminNewsletterRoute
  AuthenticatedAdminResearchRoute: typeof AuthenticatedAdminResearchRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminSlideshowRoute: typeof AuthenticatedAdminSlideshowRoute
  AuthenticatedAdminSponsorsRoute: typeof AuthenticatedAdminSponsorsRoute
  AuthenticatedAdminTeamRoute: typeof AuthenticatedAdminTeamRoute
  AuthenticatedAdminTemplatesRoute: typeof AuthenticatedAdminTemplatesRoute
  AuthenticatedAdminThemeRoute: typeof AuthenticatedAdminThemeRoute
  AuthenticatedAdminTrafficRoute: typeof AuthenticatedAdminTrafficRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAdvisorsRoute: AuthenticatedAdminAdvisorsRoute,
  AuthenticatedAdminAwardsRoute: AuthenticatedAdminAwardsRoute,
  AuthenticatedAdminBeautyShowRoute: AuthenticatedAdminBeautyShowRoute,
  AuthenticatedAdminBoardRoute: AuthenticatedAdminBoardRoute,
  AuthenticatedAdminContentRoute: AuthenticatedAdminContentRoute,
  AuthenticatedAdminEventsRoute: AuthenticatedAdminEventsRoute,
  AuthenticatedAdminGalleryRoute: AuthenticatedAdminGalleryRoute,
  AuthenticatedAdminHealthRoute: AuthenticatedAdminHealthRoute,
  AuthenticatedAdminIssuesRoute: AuthenticatedAdminIssuesRouteWithChildren,
  AuthenticatedAdminLayoutsRoute: AuthenticatedAdminLayoutsRoute,
  AuthenticatedAdminMediaRoute: AuthenticatedAdminMediaRoute,
  AuthenticatedAdminMessagesRoute: AuthenticatedAdminMessagesRoute,
  AuthenticatedAdminNavigationRoute: AuthenticatedAdminNavigationRoute,
  AuthenticatedAdminNewsRoute: AuthenticatedAdminNewsRoute,
  AuthenticatedAdminNewsletterRoute: AuthenticatedAdminNewsletterRoute,
  AuthenticatedAdminResearchRoute: AuthenticatedAdminResearchRoute,
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
  AuthenticatedAdminSlideshowRoute: AuthenticatedAdminSlideshowRoute,
  AuthenticatedAdminSponsorsRoute: AuthenticatedAdminSponsorsRoute,
  AuthenticatedAdminTeamRoute: AuthenticatedAdminTeamRoute,
  AuthenticatedAdminTemplatesRoute: AuthenticatedAdminTemplatesRoute,
  AuthenticatedAdminThemeRoute: AuthenticatedAdminThemeRoute,
  AuthenticatedAdminTrafficRoute: AuthenticatedAdminTrafficRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface BeautyShowRouteChildren {
  BeautyShowPermalinkRoute: typeof BeautyShowPermalinkRoute
}

const BeautyShowRouteChildren: BeautyShowRouteChildren = {
  BeautyShowPermalinkRoute: BeautyShowPermalinkRoute,
}

const BeautyShowRouteWithChildren = BeautyShowRoute._addFileChildren(
  BeautyShowRouteChildren,
)

interface GalleryRouteChildren {
  GalleryPermalinkRoute: typeof GalleryPermalinkRoute
}

const GalleryRouteChildren: GalleryRouteChildren = {
  GalleryPermalinkRoute: GalleryPermalinkRoute,
}

const GalleryRouteWithChildren =
  GalleryRoute._addFileChildren(GalleryRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  AuthRoute: AuthRoute,
  AwardsRoute: AwardsRoute,
  BeautyShowRoute: BeautyShowRouteWithChildren,
  BoardRoute: BoardRoute,
  GalleryRoute: GalleryRouteWithChildren,
  HomeRoute: HomeRoute,
  HomepagesRoute: HomepagesRoute,
  NewsRoute: NewsRoute,
  PitchRoute: PitchRoute,
  ResearchRoute: ResearchRoute,
  SampleRoute: SampleRoute,
  SponsorsRoute: SponsorsRoute,
  WelcomeRoute: WelcomeRoute,
  NewsSlugRoute: NewsSlugRoute,
  NewsPreviewRoute: NewsPreviewRoute,
  NewsletterSlugRoute: NewsletterSlugRoute,
  PSlugRoute: PSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
